
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-clinicians",
      function () {
        return require("private-next-pages/for-clinicians/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-clinicians"])
      });
    }
  